import React, { useState, useRef, useEffect } from 'react';
import { Input } from '@/components/ui/inputs/input';
import InputRadio from '@/components/ui/inputs/input-radio';
import { useForm, Controller } from 'react-hook-form';
import validationErrors from '@/lib/validationErrors';
import { useSelector, useDispatch } from 'react-redux';
import CommonModal from '@/components/ui/modals/CommonModal';
import { InputTextarea } from '@/components/ui/inputs/input-textarea';
import { addPagesService, updatePagesService } from '@/services/PagesServices';
import { getByIdPagesService } from '../../../../../services/PagesServices';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const AddEditModel = ({ modelTitle, openModel, setOpenModel, getTableData, editDataId = '' }) => {
    const {
        register,
        setValue,
        getValues,
        formState: { errors },
        handleSubmit,
        control,
        reset,
    } = useForm();
    const dispatch = useDispatch();

    const [itemStatus, setItemStatus] = useState(1);
    const [isCryptocurrency, setIsCryptocurrency] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [isFormSumbmit, setIsFormSumbmit] = useState(false);

    useEffect(() => {
        if (openModel && openModel != '') {
            formReset();
            if (editDataId && editDataId != '') {
                getDataById(editDataId);
            }
        }
    }, [openModel]);

    const formReset = async () => {
        try {
            var formData = getValues();
            for (const key in formData) {
                await setValue(key, '');
            }
            await reset();
            await setValue('status', '5');
            await setItemStatus(5);
        } catch (error) {
            console.error('Error in onReset:', error);
        }
    };

    const handleModelClose = () => {
        formReset();
        setOpenModel(false);
        document.body.style.overflowY = 'auto';
        getTableData();
    };

    const handleChangeRadio = (event) => {
        if (event.target.name == 'status') {
            setValue('status', event.target.value);
            setItemStatus(event.target.value);
        }
    };

    const getDataById = (editId) => {
        setIsLoading(true);
        dispatch(getByIdPagesService(editId))
            .then((res) => {
                var formData = res?.data?.data;
                for (const key in formData) {
                    if (formData.hasOwnProperty(key) && formData[key] != '') {
                        setValue(key, formData[key]);
                    } else {
                        setValue(key, '');
                    }
                }
                if (formData) {
                    setValue('status', formData.status);
                    setItemStatus(formData.status);
                }
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const onSubmit = (data) => {
        setIsFormSumbmit(true);
        var addEditService = '';
        if (editDataId && editDataId != '') {
            addEditService = updatePagesService(editDataId, data);
        } else {
            addEditService = addPagesService(data);
        }
        dispatch(addEditService)
            .then((res) => {
                formReset();
                setIsFormSumbmit(false);
                handleModelClose();
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsFormSumbmit(false);
            });
    };

    return (
        <CommonModal modelTitle={modelTitle} openModel={openModel} handleModelClose={handleModelClose}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="grid grid-cols-1 sm:grid-cols-1 gap-4">
                    <Controller
                        control={control}
                        rules={{ required: true, minLength: 2, maxLength: 20 }}
                        name="title"
                        render={({ field }) => (
                            <Input
                                {...field}
                                size="sm"
                                labelText={'Title'}
                                type="text"
                                labelStyleClassName="db-field-title required"
                                errorData={{ minLength: '2', maxLength: '20' }}
                                errorType={errors?.title?.type}
                            />
                        )}
                    />
                    <div className="form-input-item">
                        <label className="db-field-title required" htmlFor="active">
                            {'Status'}
                        </label>
                        <div className="db-field-radio-group">
                            <InputRadio
                                id="active"
                                name="status"
                                labelText={'Active'}
                                value="1"
                                onChange={() => handleChangeRadio({ target: { name: 'status', value: 1 } })}
                                checked={itemStatus == '1' ? true : false}
                            />
                            <InputRadio
                                id="inactive"
                                name="status"
                                labelText={'Inactive'}
                                value="2"
                                onChange={() => handleChangeRadio({ target: { name: 'status', value: 2 } })}
                                checked={itemStatus == '2' ? true : false}
                            />
                        </div>
                    </div>

                    <div className="form-input-item mb-5">
                        <Controller
                            control={control}
                            rules={{ required: true }}
                            name="description"
                            render={({ field }) => (
                                <ReactQuill
                                    {...field}
                                    style={{ height: '250px' }}
                                    labelText={'Description'}
                                    type="text"
                                    labelStyleClassName="db-field-title required"
                                    errorType={errors?.description?.type}
                                />
                            )}
                        />
                    </div>
                </div>

                <div className="form-col-12 mt-5">
                    <div className="flex flex-wrap gap-3 mt-4">
                        <button type="submit" className="db-btn py-2 text-white bg-primary" disabled={isFormSumbmit || isLoading ? true : false}>
                            <i className="lab lab-save"></i>
                            <span>save</span>
                            {isFormSumbmit ? (
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            ) : (
                                <></>
                            )}
                        </button>
                        <button type="button" className="modal-btn-outline modal-close" onClick={handleModelClose}>
                            <i className="lab lab-close"></i>
                            <span>close</span>
                        </button>
                    </div>
                </div>
            </form>
        </CommonModal>
    );
};

export default AddEditModel;
